import { useCallback, useRef } from 'react';
import { IFlowConfig, useEditorStore } from '@diana/core';

/**
 * caches the index of task to avoid full search whenever getting the task
 */
export const useFindTask = (taskId: string) => {
  const indexRef = useRef<number>(-1);

  const getFlow = useEditorStore((s) => s.getFlow);

  return useCallback(
    (flow?: IFlowConfig | null) => {
      const currentFlow = flow ?? getFlow();
      if (currentFlow && taskId) {
        // find via index cache
        const cache = currentFlow.steps[indexRef.current];
        if (cache && cache.taskId === taskId) {
          return cache;
        }

        // full search
        indexRef.current = currentFlow.steps.findIndex((step) => step.taskId === taskId);
        const match = currentFlow.steps[indexRef.current];
        if (match && match.taskId === taskId) {
          return match;
        }
      }

      return null;
    },
    [taskId, getFlow],
  );
};
